import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

import { useTheme } from '@/theme';

export default function WelcomeScreen() {
  const theme = useTheme();

  const welcomeContainerStyles = useMemo(
    () => ({
      alignSelf: 'center',
      alignContent: 'center',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }),
    [],
  );

  const welcomeTextBoldStyles = useMemo(
    () => ({
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 700,
      color: theme.hhglobal.purpose.textWeak,
    }),
    [theme],
  );

  const welcomeTextRegularStyles = useMemo(
    () => ({
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 400,
      color: theme.hhglobal.purpose.textWeak,
    }),
    [theme],
  );

  return (
    <Box sx={welcomeContainerStyles}>
      <Typography component='span' sx={welcomeTextBoldStyles}>
        Welcome
      </Typography>
      <Typography component='span' sx={welcomeTextRegularStyles}>
        , please select a client to view their information.
      </Typography>
    </Box>
  );
}
